import React, { useState } from 'react'
import { useMutation } from '@apollo/client';
import { Button } from '../../../common/index';
import ListNames from '../../../common/ListNames';
import { deleteTeamMemberMutation, moveTeamMemberSalesMutation } from '../../../queries/user';
import ModalTeamMember from './ModalTeamMember';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { MdOutlineSwapHoriz } from 'react-icons/md';
import { FaChevronRight } from 'react-icons/fa6';

function TeamMember({ teammember, user, setEditing, refetchTeamMembers, moveOrdersFrom, setMoveOrdersFrom }) {
  const [manageTeamMember, setManage] = useState(false);
  const [deleteTeamMember] = useMutation(deleteTeamMemberMutation);
  const [moveTeamMemberSales] = useMutation(moveTeamMemberSalesMutation);

  function handleRemove(teamMemberId, soldBooklets) {
    if (soldBooklets >= 1) {
      return (window.alert('Du kan inte radera lagmedlemmen eftersom det finns registrerade försäljningar på den. Flytta på dessa för att kunna radera lagmedlemmen.'));
    }

    if (!window.confirm('Vill du verkligen radera lagmedlemmen?'))
      return false;

    const vars = {
      variables: {
        teamMemberId: teamMemberId,
        soldBooklets: soldBooklets
      },
    };
    deleteTeamMember(vars)
      .then(result => {
        console.log('result', result);
        refetchTeamMembers();
      })
      .catch(useMutationError => {
        console.log('regErr', useMutationError, useMutationError && useMutationError.graphQLErrors)
      });
  }

  function handleMoveOrders(toTeamMemberId) {
    const vars = {
      variables: {
        toTeamMemberId: toTeamMemberId,
        fromTeamMemberId: moveOrdersFrom
      },
    };

    moveTeamMemberSales(vars)
      .then(result => {
        console.log('result', result);
        setMoveOrdersFrom(null);
        refetchTeamMembers();
      })
      .catch(useMutationError => {
        console.log('regErr', useMutationError, useMutationError && useMutationError.graphQLErrors)
      });
  }

  return (
    <>
      {manageTeamMember &&
        <ModalTeamMember user={user} teammember={teammember} setManage={setManage} refetchTeamMembers={refetchTeamMembers} />
      }
      <tr id={'user_' + teammember._id} className={`c-pointer ${!teammember.isApprovedByGuardian ? 'inactive' : ''}`}
        onClick={() => setManage(true)}
      >
        <td>
          <p className={`m-0 ${teammember?.adminEmails?.length === 0 ? 'inactive' : ''}`}>{`${teammember.firstname} ${teammember.lastname}`}</p>
          {teammember?.adminEmails?.length === 0 && <span className="small inactive">Målsman saknas</span>}
          {teammember?.adminEmails?.length > 0 && <ListNames emails={teammember?.adminEmails} />}
          <span className="small italic">{!teammember.isApprovedByGuardian && 'Inväntar godkännande...'}</span>
        </td>
        <td>
          <div className="table-icon-buttons">
            {/* Redigera */}
            {user.superAdmin && (
              <div
                className="table-icon-btn"
                role="button"
                tabIndex={0}
                title="Redigera"
                onClick={(e) => { e.stopPropagation(); setEditing(teammember._id); }}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); setEditing(teammember._id); } }}
              >
                <FiEdit size={14} />
              </div>
            )}
            {/* Flytta */}
            {(moveOrdersFrom === null && user.superAdmin && teammember.soldBooklets !== 0) && (
              <div
                className="table-icon-btn"
                role="button"
                tabIndex={0}
                title="Flytta försäljning"
                onClick={(e) => { e.stopPropagation(); setMoveOrdersFrom(teammember._id); }}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); setMoveOrdersFrom(teammember._id); } }}
              >
                <MdOutlineSwapHoriz size={14} />
              </div>
            )}
            {(moveOrdersFrom === teammember._id && user.superAdmin) && (
              <Button className="xs secondary" size="xs" onClick={(e) => { e.stopPropagation(); setMoveOrdersFrom(null); }}>Avbryt</Button>
            )}
            {(moveOrdersFrom !== null && moveOrdersFrom !== teammember._id && user.superAdmin) && (
              <Button className="xs secondary" size="xs" onClick={(e) => { e.stopPropagation(); handleMoveOrders(teammember._id); }}>Flytta hit</Button>
            )}
            {/* Radera */}
            {user?.superAdmin && (
              <div
                className="table-icon-btn"
                role="button"
                tabIndex={0}
                title="Radera"
                onClick={(e) => { e.stopPropagation(); handleRemove(teammember._id, teammember.soldBooklets); }}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); handleRemove(teammember._id, teammember.soldBooklets); } }}
              >
                <FiTrash2 size={14} />
              </div>
            )}
            <div className="table-icon-btn">
              <FaChevronRight size={14} />
            </div>
          </div>
        </td>
      </tr>
    </>
  )
}

export default TeamMember
